/**
 * Hambi API Service
 * Hambi/Beeline app-тай холбогдох API хүсэлтүүд
 */

import { API_BASE_URL } from '../api/config';

const BACKEND_URL = API_BASE_URL;

/**
 * Authenticate Hambi user and get JWT token
 * This provides the same authentication as Toki/Phone OTP,
 * allowing Hambi users to access all hrSystemServer endpoints.
 *
 * @param {string} token - Hambi token from URL
 * @returns {Promise<Object>} - { success, token, candidateId, data }
 */
export const authenticateHambiUser = async (token) => {
    try {
        const response = await fetch(`${BACKEND_URL}/v1/hambi/auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ token })
        });

        const data = await response.json();

        if (data.success) {
            return {
                success: true,
                token: data.token,
                refreshToken: data.refreshToken,
                candidateId: data.candidateId,
                data: data.data
            };
        } else {
            return {
                success: false,
                error: data.error || 'Failed to authenticate'
            };
        }
    } catch (error) {
        console.error('Hambi authenticate error:', error);
        return {
            success: false,
            error: error.message || 'Authentication error'
        };
    }
};

/**
 * Хэрэглэгчийн бүтэн нэр авах
 * custom_name байвал түүнийг, байхгүй бол first_name + last_name
 * 
 * @param {Object} hambiUser - Hambi user object
 * @returns {string} - Full name
 */
export const getFullName = (hambiUser) => {
    if (!hambiUser) return '';

    if (hambiUser.custom_name && hambiUser.custom_name.trim()) {
        return hambiUser.custom_name;
    }

    const parts = [];
    if (hambiUser.first_name && hambiUser.first_name !== '_') {
        parts.push(hambiUser.first_name);
    }
    if (hambiUser.middle_name) {
        parts.push(hambiUser.middle_name);
    }
    if (hambiUser.last_name) {
        parts.push(hambiUser.last_name);
    }

    return parts.join(' ');
};

/**
 * Утасны дугаарыг форматлах (998XXXXXXXXX -> +998 XX XXX XX XX)
 * 
 * @param {string} phoneNumber - Phone number
 * @returns {string} - Formatted phone number
 */
export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';

    // Remove all non-digits
    const digits = phoneNumber.replace(/\D/g, '');

    if (digits.length === 12 && digits.startsWith('998')) {
        // Format: +998 XX XXX XX XX
        return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
    }

    return phoneNumber;
};

export default {
    authenticateHambiUser,
    getFullName,
    formatPhoneNumber
};
